@if (loadingUser()) {
  <div class="initials loading-state"></div>
} @else {
  @let showStatus = online() !== undefined || snoozed() !== undefined;
  @let isSnoozed = !!snoozed();
  @let showCount = numberBadge() !== undefined && numberBadge()! > 0;
  @let deletedUser = isDeleted();
  @let displayName = name();
  @let showConnection = showConnectionIcon();
  @let guest = isGuest();
  @let pipAvatar = isPip();

  <div
    class="avatar-container hflex-000 flex-align-items-center flex-justify-content-center"
    [class.show-status]="!pipAvatar && !deletedUser && showStatus && !showConnection"
    [class.snoozed]="!pipAvatar && !deletedUser && isSnoozed && !showConnection"
    [class.show-count]="!pipAvatar && showCount && !showConnection"
    [class.show-connection]="!pipAvatar && !!showConnection"
    [class.is-guest]="!pipAvatar && guest"
  >
    @if (pipAvatar) {
      <img [src]="pipAvatarSrc()" [alt]="alt() || name()" (error)="onPipAvatarError()" />
    } @else if (isDeleted()) {
      <mdw-icon class="initials deleted-user" [icon]="icons.User_Fill"></mdw-icon>
    } @else if (icon()) {
      <mdw-icon class="initials brand-icon" [icon]="icon()!"></mdw-icon>
    } @else if (srcWithVersion()) {
      <img [src]="srcWithVersion()" [alt]="alt() || name()" />
    } @else if (displayName && displayName.length > 0) {
      <div class="initials" [ngClass]="'scheme-' + color()">
        {{ displayName[0] }}
      </div>
    }
  </div>

  @if (!pipAvatar) {
    @if (showConnection) {
      <mdw-icon
        [icon]="icons.ExternalConnection_Fill"
        class="connection-icon color-preset-3"
      ></mdw-icon>
    } @else if (numberBadge() !== undefined && numberBadge()! > 0) {
      @switch (numberBadge()) {
        @case (1) {
          <mdw-icon [icon]="icons.BadgeNumber_1" [ngClass]="size() + '-icon'"></mdw-icon>
        }
        @case (2) {
          <mdw-icon [icon]="icons.BadgeNumber_2" [ngClass]="size() + '-icon'"></mdw-icon>
        }
        @case (3) {
          <mdw-icon [icon]="icons.BadgeNumber_3" [ngClass]="size() + '-icon'"></mdw-icon>
        }
        @case (4) {
          <mdw-icon [icon]="icons.BadgeNumber_4" [ngClass]="size() + '-icon'"></mdw-icon>
        }
        @case (5) {
          <mdw-icon [icon]="icons.BadgeNumber_5" [ngClass]="size() + '-icon'"></mdw-icon>
        }
        @case (6) {
          <mdw-icon [icon]="icons.BadgeNumber_6" [ngClass]="size() + '-icon'"></mdw-icon>
        }
        @case (7) {
          <mdw-icon [icon]="icons.BadgeNumber_7" [ngClass]="size() + '-icon'"></mdw-icon>
        }
        @case (8) {
          <mdw-icon [icon]="icons.BadgeNumber_8" [ngClass]="size() + '-icon'"></mdw-icon>
        }
        @case (9) {
          <mdw-icon [icon]="icons.BadgeNumber_9" [ngClass]="size() + '-icon'"></mdw-icon>
        }
        @default {
          <mdw-icon [icon]="icons.BadgeNumber_9plus" [ngClass]="size() + '-icon'"></mdw-icon>
        }
      }
    } @else {
      <!-- Status Indicators -->
      @if (online() && snoozed()) {
        <mdw-icon
          [icon]="guest ? icons.StatusGuest_Online_snoozed : icons.Status_Online_snoozed"
          class="status-icon online"
          [ngClass]="size() + '-icon'"
        ></mdw-icon>
      } @else if (online()) {
        <mdw-icon
          [icon]="guest ? icons.StatusGuest_Online : icons.Status_Online"
          [ngClass]="size() + '-icon'"
          class="status-icon online"
        ></mdw-icon>
      } @else if (snoozed()) {
        <mdw-icon
          [icon]="guest ? icons.StatusGuest_Offline_snoozed : icons.Status_Offline_snoozed"
          [ngClass]="size() + '-icon'"
          class="status-icon"
        ></mdw-icon>
      } @else if (online() === false) {
        <mdw-icon
          [icon]="guest ? icons.StatusGuest_Offline : icons.Status_Offline"
          [ngClass]="size() + '-icon'"
          class="status-icon"
        ></mdw-icon>
      }
    }
  }
}
